var map = {
	"./border-bg-sm.png": 1385,
	"./border-bg.png": 1386,
	"./btn-active.png": 1387,
	"./cny-mobile-bg.webp": 1388,
	"./content-deco-1.webp": 1389,
	"./content-deco-2.webp": 1390,
	"./content-deco-3.webp": 1391,
	"./content-deco-4.webp": 1392,
	"./content-deco-5.webp": 1393,
	"./deposit-icon.webp": 1394,
	"./home-icon-active.webp": 1395,
	"./home-icon.webp": 1396,
	"./live-icon-active.webp": 1397,
	"./live-icon.webp": 1398,
	"./master-bg.png": 1399,
	"./me-icon-active.webp": 1400,
	"./me-icon.webp": 1401,
	"./platform.webp": 1402,
	"./product-overview-bg.webp": 1403,
	"./promos-icon-active.webp": 1404,
	"./promos-icon.webp": 1405,
	"./sponsor-icon-active.webp": 1406,
	"./sponsor-icon.webp": 1407,
	"./title-deco-bg.webp": 1408,
	"./title-deco-left.webp": 1409,
	"./title-deco-right.webp": 1410,
	"./vip-icon-active.webp": 1411,
	"./vip-icon.webp": 1412,
	"./withdraw-icon.webp": 1413,
	"./wwr-bg.webp": 1414,
	"./wwr-img.webp": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;